"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const getTouchscreen_1 = require("../utils/getTouchscreen");
function default_1() {
    let w = window;
    let nav = w.navigator;
    return {
        touchscreen: (0, getTouchscreen_1.default)(),
        cpu: {
            // @ts-ignore
            name: nav.oscpu || "",
            cores: nav.hardwareConcurrency || 0
        },
        sizes: {
            usable: {
                height: w.outerHeight,
                width: w.outerWidth,
            },
            screen: {
                height: screen.height,
                width: screen.width
            }
        },
        // @ts-ignore
        memory: nav.deviceMemory || 0,
        color: {
            depth: screen.colorDepth,
            contrast: "",
            gamut: "",
            forcedColors: false,
            hdr: false,
            monochromeDepth: 0
        },
    };
}
exports.default = default_1;
